// extracted by mini-css-extract-plugin
module.exports = {"link":"detail_link__3JUXq","btnAddFiles":"detail_btnAddFiles__1uGRg"};